export default {
    Close: "Close",
    Change: "Change",
    MediaSwitchFailed: "Media switch failed!",
}